export const initialAddressValue = {
  country: '' as any,
  city: '' as any,
  state: '' as any,
  address_1: '' as any,
  address_2: '' as any,
  zip_code: '' as any,
};
